import { render, staticRenderFns } from "./PlotDepth.vue?vue&type=template&id=663d0e91&"
import script from "./PlotDepth.vue?vue&type=script&lang=ts&"
export * from "./PlotDepth.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports